import { useState } from 'react';
import { Icon, Text, Button, Flex, TextField } from '@vibe/core';
import { AppModal, AppModalContent, AppModalFooter } from '@gorilla/ui/src/components/AppModal';
import { Edit } from '@vibe/icons';
import { Sheet as SheetType } from '@gorilla/spreadsheet-shared/src/lib/spreadsheet-manager/types';

type EditWorksheetNameModalProps = {
  show: boolean;
  sheet: SheetType;
  onClose: (newSheetName?: string) => void;
};

export function EditWorksheetNameModal({ show, sheet, onClose }: EditWorksheetNameModalProps) {
  const [newSheetName, setNewSheetName] = useState(sheet.name);

  return (
    <AppModal
      show={show}
      onClose={() => {
        onClose();
      }}
      width="default"
      alertDialog={false}
    >
      <AppModalContent>
        <Flex direction="row" align="center" gap={4} style={{ marginBottom: '24px' }}>
          <Flex gap={8}>
            <Icon icon={Edit} size={20} />
            <div style={{ maxWidth: '200px' }}>
              <Text type="text1" weight="medium" ellipsis>
                Edit worksheet name
              </Text>
            </div>
          </Flex>
        </Flex>
        <TextField value={newSheetName} size="large" onChange={setNewSheetName} />
      </AppModalContent>
      <AppModalFooter>
        <Flex gap={12} justify="end">
          <Button
            kind="tertiary"
            size="medium"
            onClick={() => {
              onClose();
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={!newSheetName}
            kind="primary"
            size="medium"
            onClick={() => {
              onClose(newSheetName);
            }}
          >
            Confirm
          </Button>
        </Flex>
      </AppModalFooter>
    </AppModal>
  );
}
